import { type SystemPreferenceKeysEnum } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

/**
 * Thrown when a write's response echo carries no entry for the requested key.
 * Reads never throw it: a never-set preference resolves `null` instead.
 */
export class SystemPreferenceNotFoundError extends Error {
  name = 'SystemPreferenceNotFoundError'

  constructor(public readonly key: SystemPreferenceKeysEnum) {
    super(`Invalid system preference key: ${key}`)
  }
}
